import { useQuery } from '@apollo/client'
import Table, { ColumnsType } from 'antd/lib/table'
import dayjs from 'dayjs'
import { DEMANDE_RAPPEL_QUERY } from '../../apollo/query/demande.query'
import { EtatRappelTelephonique } from '../../constants'
import { D4_Demande } from '../../types'

const columns: ColumnsType<D4_Demande> = [
  {
    title: 'Date Appel',
    dataIndex: 'dateappel',
    key: 'dateappel',
    render: (text) => dayjs(text).format('DD/MM/YYYY HH:mm'),
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Qui doit rappeler',
    dataIndex: 'gestionnairequidoitrappeler',
    key: 'gestionnairequidoitrappeler',
    render: (text, record) =>
      `${record?.gestionnairequidoitrappeler?.nom} ${record?.gestionnairequidoitrappeler?.prenom}` ?? '',
  },
  {
    title: 'Historique',
    dataIndex: 'historique',
    key: 'historique',
    render: (_, record) => {
      if (record.rappel.length === 0) return 'Pas de rappel'
      return record.rappel.map((rap) => (
        <div key={rap.id}>
          Rappelé le {dayjs(rap.daterappel).format('DD/MM/YYYY')} par {rap.auteur?.nom} - {rap.auteur?.prenom} <br />
          {EtatRappelTelephonique[rap.etatrappeltelephonique]}
        </div>
      ))
    },
  },
]

/**
 * dateappel, desc, personne qui a rappelé, date rappel - auteur - code - texte rappel
 * @param param0
 * @returns
 */

const TableDemandeDeRappel = ({ emetteurId }: { emetteurId: number }) => {
  const { data } = useQuery<{ demandes: D4_Demande[] }, { emetteurId: number }>(DEMANDE_RAPPEL_QUERY, {
    skip: !emetteurId,
    variables: { emetteurId },
    fetchPolicy: 'network-only',
  })
  if (!data?.demandes) {
    return null
  }

  return (
    <Table
      pagination={{ pageSize: 3, position: ['bottomLeft'] }}
      size="small"
      columns={columns}
      dataSource={data?.demandes}
    />
  )
}

export default TableDemandeDeRappel
